var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_6816_10739)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6816_10739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.125C12.518 16.125 12.9375 16.5445 12.9375 17.0625C12.9375 17.5805 12.518 18 12 18C11.482 18 11.0625 17.5805 11.0625 17.0625C11.0625 16.5445 11.482 16.125 12 16.125ZM12 6C12.6211 6 13.125 6.50391 13.125 7.125C13.125 7.13906 13.125 7.15078 13.125 7.16484L12.75 14.2898C12.7289 14.6883 12.3984 15 12 15C11.6016 15 11.2734 14.6883 11.25 14.2898L10.875 7.16484C10.875 7.15078 10.875 7.13906 10.875 7.125C10.875 6.50391 11.3789 6 12 6Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6816_10739",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47223"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6816_10739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 12,
    fill: "white",
    transform: "translate(10.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.521490b0d8544d0b216ba709bcdd844c.svg";
export { ForwardRef as ReactComponent };